const TEAM_NAME = `team_name`;
export { TEAM_NAME, };
